module.exports = __webpack_public_path__ + "static/media/infiline-logo.d5c91a77.png";